import type { SelfServiceAPI } from 'types';
import type { Options } from '../types';
import api from 'lib/axios/api';
import getFilename from '../utils/getFilename';
import downloadFile, { FileType } from '../utils/downloadFile';
import handleServiceError from '../utils/handleServiceError';

const downloadInvoicePdf = async (booking: SelfServiceAPI.Booking, options: Options = {}): Promise<void> => {
  try {
    const { headers, data } = await api.get(booking.links.downloadInvoice, {
      url: booking.links.downloadInvoice,
      responseType: 'blob',
    });

    const filename = getFilename(headers);
    downloadFile(filename || `tax-invoice-${booking.reference}.pdf`, data, FileType['application/pdf']);
  } catch (error) {
    handleServiceError(error, {
      operationName: `GET ${booking.links.downloadInvoice}`,
      skipUnauthenticatedRedirection: options.skipUnauthenticatedRedirection,
    });

    return new Promise(() => {});
  }
};

export default downloadInvoicePdf;
